export const TerminalVersion = "v3.2.4";
export const TerminalVersionSHA = "800dc93";
